(ns key-accomplishments.views
  (:require
    [reagent.core :as r]
    [very.re-frame.core :as rf]
    [main.common :as common]
    [css.core :refer [defstyled get-theme]]
    [css.form :as form]
    [css.vars :as vars]
    [profile.common :as pc]))

(defstyled event-input-row-s :div
  {:display "grid"
   :grid-gap "2rem"
   :grid-template-columns "75fr 25fr"})

(defstyled list-item-s :div
  {:margin-bottom "2rem"
   :padding-bottom "2rem"
   :border-bottom (str "1px solid " (get-theme :primary))})

(defn- empty-ka []
  {:name ""
   :notes ""
   :date-completed ""
   :tmp? true
   :id (random-uuid)})

(defn- hydrate [kas]
  (if (empty? kas) [(empty-ka)] (mapv #(assoc % :id (random-uuid)) kas)))

(defn manage [{:keys [on-save on-cancel]}]
  (let [kas (rf/subscribe [:key-accomplishments])
        f (atom {})
        tmp-kas (r/atom (hydrate @kas))
        add #(swap! tmp-kas conj (empty-ka))
        remove (fn [ka] (swap! tmp-kas (fn [kas] (remove #(= (:id %) (:id ka)) kas))))
        extract-form-values (fn [ka f]
                              (reduce (fn [m [k field]] (assoc m k (.-value field)))
                                      {}
                                      (get f (:id ka))))
        gather (fn [e]
                 (.preventDefault e)
                 (let [kas (reduce (fn [coll ka] (conj coll (extract-form-values ka @f))) [] @tmp-kas)]
                   (on-save kas)))]
    (fn []
      [common/form-page-s
       [common/form-s {:on-submit gather}
        [pc/form-section-s
         [pc/form-section-header-s
          [pc/form-section-title-s "Key accomplishments"]]
         [pc/form-section-description-s {:margin "3rem 0 1.75rem"} "Tell us about the milestones you have reached this year like personal achievements or fulfilling life long goals."]
         [:div
          [:ul
           (for [ka @tmp-kas]
             ^{:key (str (:id ka))}
             [list-item-s
              [event-input-row-s
               [form/input-row-s
                [form/input-label-s "Event"]
                [form/input {:type "text"
                             :default-value (:name ka)
                             :required true
                             :placeholder "Event"
                             :max-width "100%"
                             :label? true
                             :ref #(swap! f assoc-in [(:id ka) :name] %)}]]
               [form/input-row-s
                [form/input-label-s "Date"]
                [form/past-date {:default-value (:date-completed ka)
                                 :required true
                                 :label? true
                                 :ref #(swap! f assoc-in [(:id ka) :date-completed] %)}]]]
              [form/input-row-s
               [form/input-label-s "Notes"]
               [form/textarea-s {:default-value (:notes ka)
                                 :placeholder "Notes"
                                 :label? true
                                 :ref #(swap! f assoc-in [(:id ka) :notes] %)}]]
              [common/center-s
               [form/naked-button-s {:on-click #(remove ka)
                                     :type "button"
                                     :font-size "16px"}
                [form/naked-button-symbol-s "−"]
                [form/naked-button-text-s "Remove accomplishment"]]]])]]
         [common/center-s
          [form/naked-button-s {:on-click add
                                :type "button"
                                :font-size "16px"
                                :margin "0"}
           [form/naked-button-symbol-s "+"]
           [form/naked-button-text-s "Add another accomplishment"]]]
         [form/button-row-s
          [form/secondary-button-s {:on-click on-cancel
                                    :type "button"} "Previous"]
          [form/button {:type "submit"} "Save"]]]]])))
